import { IconCalendar16, IconFunctionalErrorCircle16 } from '@cian/ui-kit';
// eslint-disable-next-line import/default
import React, { useCallback, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { v4 as uuid } from 'uuid';

import { trackSetFrequencyClick, trackTuneFrequencyClick } from './tracking';
import { toggleChatbotPeriodicityMenu } from '../../actions/chatbot/actions';
import { addTextMessageToChat, setSendMessageAbort } from '../../actions/sendMessage';
import { ChatbotButton, ChatbotButtonPeriodicity } from '../../components/ChatbotButton';
import { CHATBOT_ID } from '../../constants/chatbotId';
import { chatbotSelector } from '../../selectors';
import { EPeriodicity } from '../../services/fetchChatbotMessages';
import { applyPeriodicitySettings } from '../../thunks/chatbot';
import { TMessageSchema } from '../../types/messages';
import { TThunkDispatch } from '../../types/redux/thunk';

export const TunePeriodicityButtonContainer: React.FC = () => {
  const [outcomingMessageId] = useState([uuid(), uuid()]);
  const dispatch = useDispatch<TThunkDispatch>();
  const { periodicity, isPeriodicityMenuOpened } = useSelector(chatbotSelector);
  const buttons = [
    {
      name: EPeriodicity.Daily,
      title: 'Раз в день',
    },
    {
      name: EPeriodicity.EveryThreeDays,
      title: 'Раз в три дня',
    },
    {
      name: EPeriodicity.Weekly,
      title: 'Раз в неделю',
    },
  ];

  const handleTunePeriodicityClick = useCallback(() => {
    if (!isPeriodicityMenuOpened) {
      trackTuneFrequencyClick();
      dispatch(addTextMessageToChat('Настроить регулярность', CHATBOT_ID, outcomingMessageId[0]));
      dispatch(
        addTextMessageToChat('Как часто вы хотели бы получать такие подборки?', CHATBOT_ID, outcomingMessageId[1], 0),
      );
    }

    dispatch(toggleChatbotPeriodicityMenu());
  }, [dispatch, isPeriodicityMenuOpened, outcomingMessageId]);

  const handlePeriodicityChange = useCallback(
    (value?: EPeriodicity) => {
      if (value) {
        trackSetFrequencyClick(value);
        dispatch(applyPeriodicitySettings(value)).finally();
      } else {
        trackSetFrequencyClick();
      }

      dispatch(
        setSendMessageAbort({
          message: { chatId: CHATBOT_ID } as TMessageSchema,
          messageId: outcomingMessageId[0],
        }),
      );
      dispatch(
        setSendMessageAbort({
          message: { chatId: CHATBOT_ID } as TMessageSchema,
          messageId: outcomingMessageId[1],
        }),
      );

      dispatch(toggleChatbotPeriodicityMenu(false));
    },
    [dispatch, outcomingMessageId],
  );

  return (
    <>
      {!isPeriodicityMenuOpened && (
        <ChatbotButton
          theme="fill_white_primary"
          beforeIcon={<IconCalendar16 color="primary_100" />}
          onClick={handleTunePeriodicityClick}
        >
          Настроить регулярность
        </ChatbotButton>
      )}

      {isPeriodicityMenuOpened && (
        <>
          {buttons.map(({ name, title }) => (
            <ChatbotButtonPeriodicity
              key={name}
              isActive={periodicity === name}
              onClick={() => handlePeriodicityChange(name)}
            >
              {title}
            </ChatbotButtonPeriodicity>
          ))}

          <ChatbotButton
            theme="fill_white_primary"
            beforeIcon={<IconFunctionalErrorCircle16 color="primary_100" />}
            onClick={() => handlePeriodicityChange()}
          >
            Оставить как есть
          </ChatbotButton>
        </>
      )}
    </>
  );
};
